/* sd-desc-clean.js — client-side guard for the "sdd" spec-sheet description.
 * Rules (Onur, 2026-09-09): no part numbers in the bill of materials (every
 * parenthesised group is dropped), internal import notes ("Hermes AI import |
 * CFG-xxxx | ... checked") are never shown, RAM reads plainly as "64GB DDR4"
 * (no RDIMM / ECC / MHz detail). The product body_html is cleaned server-side
 * with the same rules (scripts/shopify-desc-clean.ts); this is the safety net
 * for anything re-imported later. */
(function () {
  function collapse(s) {
    return s.replace(/\s+/g, " ").replace(/\s+([,;.)])/g, "$1").replace(/[;,]\s*$/g, "").trim();
  }
  function stripParens(t) {
    var prev;
    do { prev = t; t = t.replace(/\s*\([^()]*\)/g, ""); } while (t !== prev);
    t = t.replace(/\s*\([^()]*$/, "");
    t = t.replace(/\b(?:PN|P\/N)\s*[:#]?\s*[A-Z0-9][A-Z0-9\/-]{3,}\b/gi, "");
    return collapse(t);
  }
  function gensOf(t) {
    var m = t.match(/DDR\d/gi) || [], out = [];
    for (var i = 0; i < m.length; i++) { var g = m[i].toUpperCase(); if (out.indexOf(g) < 0) out.push(g); }
    return out;
  }
  function simplifyMem(t) {
    var cap = t.match(/(\d+(?:\.\d+)?)\s*(GB|TB)\b/i), gens = gensOf(t);
    if (cap && gens.length) return cap[1] + cap[2].toUpperCase() + " " + gens.join("/");
    return collapse(
      t.replace(/\b(L?RDIMM|UDIMM|SODIMM|ECC|Registered|Unbuffered|Buffered|Load[- ]Reduced)\b/gi, "")
       .replace(/\b\d+\s*(?:MT\/s|MHz)\b/gi, "")
       .replace(/\bPC\d-\d+[A-Z]?\b/gi, "")
       .replace(/\b\d+Rx\d+\b/gi, "")
       .replace(/\bup to\s*$/i, "")
    );
  }
  function memType(t) { var g = gensOf(t); return g.length ? g.join("/") : simplifyMem(t); }
  var INTERNAL = /hermes|\bCFG-\d+|\bchecked\b|\bimport\b|\bworkbook\b|\bcorrected\b/i;
  function cleanNote(t) {
    var segs = t.split("|"), kept = [];
    for (var i = 0; i < segs.length; i++) {
      var seg = segs[i].trim();
      if (!seg) continue;
      if (!INTERNAL.test(seg)) { kept.push(seg); continue; }
      var sentences = seg.split(/\.\s+(?=[A-Z0-9])/), good = [];
      for (var j = 0; j < sentences.length; j++) {
        var s = sentences[j].trim();
        if (!s) continue;
        if (j < sentences.length - 1 && !/\.$/.test(s)) s += ".";
        if (!INTERNAL.test(s)) good.push(s);
      }
      if (good.length) kept.push(good.join(" "));
    }
    return collapse(kept.join(" "));
  }
  function memLi(t) {
    return t.replace(/(\d+(?:\.\d+)?\s*(?:GB|TB))\s+(DDR\d)\s+ECC Registered Memory/gi, function (_, c, g) {
      return c.replace(/\s+/g, "") + " " + g.toUpperCase() + " memory";
    });
  }
  function textNodes(el, skip) {
    var out = [];
    for (var n = el.firstChild; n; n = n.nextSibling) if (n !== skip && n.nodeType === 3) out.push(n);
    return out;
  }
  function clean(root) {
    var i, j, list;
    list = root.querySelectorAll(".sdd table.bm td:not(.q)");
    for (i = 0; i < list.length; i++) {
      var td = list[i], k = td.querySelector("span.k"), kind = k ? k.textContent.trim() : "";
      var nodes = textNodes(td, k);
      for (j = 0; j < nodes.length; j++) {
        var t = nodes[j].textContent; if (!t.trim()) continue;
        var s = (/^memory$/i.test(kind) || (/DDR\d/i.test(t) && /\b(L?RDIMM|UDIMM|ECC|Registered|MHz|MT\/s)\b/i.test(t)))
          ? simplifyMem(stripParens(t)) : stripParens(t);
        if (s !== t) nodes[j].textContent = s;
      }
    }
    list = root.querySelectorAll(".sdd .gd div");
    for (i = 0; i < list.length; i++) {
      var kk = list[i].querySelector("span.k"), v = list[i].querySelector("span.v");
      if (!kk || !v) continue;
      var key = kk.textContent.trim();
      if (key === "Memory type") { var mt = memType(v.textContent); if (mt !== v.textContent) v.textContent = mt; }
      else if (key === "Memory installed") { var mi = simplifyMem(v.textContent); if (mi !== v.textContent) v.textContent = mi; }
    }
    list = root.querySelectorAll(".sdd ul.ft li");
    for (i = 0; i < list.length; i++) { var li = memLi(list[i].textContent); if (li !== list[i].textContent) list[i].textContent = li; }
    list = root.querySelectorAll(".sdd p.nt");
    for (i = 0; i < list.length; i++) {
      var p = list[i], pk = p.querySelector("span.k"), tn = textNodes(p, pk), raw = "";
      for (j = 0; j < tn.length; j++) raw += tn[j].textContent + " ";
      raw = raw.replace(/\s+/g, " ").trim();
      var cn = cleanNote(raw);
      if (!cn) { p.parentNode && p.parentNode.removeChild(p); continue; }
      if (cn !== raw) { for (j = 0; j < tn.length; j++) p.removeChild(tn[j]); p.appendChild(document.createTextNode(cn)); }
    }
  }
  function run() { try { clean(document); } catch (e) { /* never break the page */ } }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run); else run();
})();
